/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Seo_Items_DescriptionInputs */

const he_seo_items_description = /** @type {(inputs: Seo_Items_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`עיינו בכל מוצרי KSP עם גרפי היסטוריית מחירים. השוו מחירים, מצאו מבצעים ועקבו אחרי ירידות מחירים.`)
};

const en_seo_items_description = /** @type {(inputs: Seo_Items_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Browse all KSP products with price history charts. Compare prices, find deals, and track price drops on electronics and more.`)
};

/**
* | output |
* | --- |
* | "Browse all KSP products with price history charts. Compare prices, find deals, and track price drops on electronics and more." |
*
* @param {Seo_Items_DescriptionInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const seo_items_description = /** @type {((inputs?: Seo_Items_DescriptionInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seo_Items_DescriptionInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_seo_items_description(inputs)
	return en_seo_items_description(inputs)
});